export default {
      id: "ms_pay-usage",
      viewBox: "0 0 37 17",
      url: __webpack_public_path__ + "sprite.svg#ms_pay",
      toString: function () {
        return this.url;
      }
    }